import * as React from 'react';

import styles from './ImageWithTextMessageLayout.css';
import { EMessageType } from '../../types/messageType';
import { EUserColor } from '../../types/userName';
import { ChatMessageBubble } from '../ChatMessageBubble';
import { ChatMessage } from '../ChatMessage';

interface IImageWithTextMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  imageMessage: React.ReactNode;
  textMessage: React.ReactNode;
  messageMeta: React.ReactNode;
  actionButtons: React.ReactNode;
  userColor?: EUserColor;
  replyQuote: React.ReactNode | null;
  highlighted?: boolean;
  onHighlightEnd?: VoidFunction;
}

export const ImageWithTextMessageLayout = React.forwardRef<HTMLDivElement, IImageWithTextMessageLayoutProps>(
  function ImageWithTextMessageLayout(
    {
      errorSign,
      errorText,
      messageType,
      isLastMessageInChain,
      imageMessage,
      textMessage,
      messageMeta,
      actionButtons,
      userColor,
      replyQuote,
      highlighted,
      onHighlightEnd,
    },
    ref,
  ) {
    return (
      <ChatMessage errorSign={errorSign} errorText={errorText} className={styles['container']}>
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['bubble']}
          ref={ref}
          userColor={userColor}
          highlighted={highlighted}
          onHighlightEnd={onHighlightEnd}
        >
          <div className={styles['quote']}>{replyQuote}</div>
          {imageMessage}
          <div className={styles['layout']}>
            <div className={styles['content']}>
              <div className={styles['text-message']}>{textMessage}</div>
              <div className={styles['action-buttons']}>{actionButtons}</div>
            </div>
            <div className={styles['meta']}>{messageMeta}</div>
          </div>
        </ChatMessageBubble>
      </ChatMessage>
    );
  },
);
